// 管理台统一格式化：此前同一后台并存 5 种日期写法、3 处金额换算,全部收敛到这里。

/** 统一日期时间：2026-07-19 14:30:05;空值返回 "-"。 */
export const formatDateTime = (value?: string | number | Date | null): string => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

/** 分 → 元展示:formatCents(12345) === "¥123.45";空值返回 "-"。 */
export const formatCents = (cents?: number | null): string => {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return "-";
  return `¥${(cents / 100).toFixed(2)}`;
};
